import { useState } from "react"
import BlogPostGallery from "./blog-post-gallery"
import Pagination from "./pagination"

const BlogHome = () => {
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)

  return (
    <div className="relative w-full bg-paper pt-16 pb-[80px] md:pb-[116px] overflow-hidden -mt-16">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-secondary/15 pointer-events-none" />
      <div className="relative">
        <BlogPostGallery
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setTotalPages={setTotalPages}
        />

        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={(page) => {
            setCurrentPage(page)
          }}
        />
      </div>
    </div>
  )
}

export default BlogHome